import { Component, Input, OnInit } from '@angular/core'
import { classifyImc } from './imc-classification'

@Component({
	selector: 'app-body-data',
	templateUrl: './body-data.component.html',
	styleUrls: ['./body-data.component.scss'],
})
export class BodyDataComponent implements OnInit {
	@Input() weight: string = ''
	@Input() height: string = ''
	@Input() visceralFat: string = ''
	@Input() fatPercentage: string = ''
	@Input() musclePercentage: string = ''
	@Input() imc: string = ''
	typeMessage = {
		type: '',
		status: '',
	}

	constructor() {}

	ngOnInit(): void {
		this.verify()
	}

	parseToDecimal(number: string | undefined, fraction: number = 2) {
		if(!number)
			return '00.00'
		return parseFloat(number).toFixed(fraction)
	}

	verify() {
		const range = classifyImc(parseFloat(this.imc))
		this.typeMessage = {
			type: range ? range.type : '',
			status: range ? range.status : '',
		}
	}
}
